import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventOccurrences = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['occurrences'] => getEvent(eventKey)(store).occurrences;
